//import { Preferences } from '@capacitor/preferences';
import { Storage, Drivers } from '@ionic/storage';
import { _ALIAS_SUFFIX, _NEW_LINE, _SERVER_URL_IMAGES_1, _SERVER_URL_RP, _SMALL_SCREEN_WIDTH, _cachedLocalAutoL2image, _cardVisibilityPrefix, _debugMode, _dict, _fixedMappingDict, _l2image, _l2visibility, _libName, _maxSentenceLen, _pathSeparator, _photoPrefix, _preferencesKeyPrefix, _rootName, _soundPrefix, _userUniqueId, remoteSharedLocation } from './constants';
import { Browser } from '@capacitor/browser';
import pako from 'pako';
import { DataDict } from './types';
import * as XLSX from 'xlsx';
import { addWord, checkRemoteObject, downObject, firebaseStorage, upObject } from './sync';
import { ref, getBlob} from '@firebase/storage';
import { addOrUpdateWord } from '../foo/firedb';
import { getBase64FromURL } from '../foo/images';

let CryptoJS = require("crypto-js");

export const ionicStorage = new Storage({driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage]});
ionicStorage.create()

/*
async function initStorage() {
  await storage.create();
}
initStorage();
*/

// Map input string to a simpe id
export function mapToId(input: string | null | undefined) {
  if (input == null) {
    return "";
  }
  return input.replace(/[^a-zA-Z0-9]/g, "_");
}

// Custom function
export const customStorage = {
  getItem: async (key: string) => {
    return await load(key, null);

  },
  setItem: async (key: string, value: any) => {
    await store(key, value);
  },
  removeItem: async (key: string) => {
    try {
      // Ensure '_preferencesKeyPrefix' is defined globally
      await ionicStorage.remove(_preferencesKeyPrefix + key); 
    } catch (error) {
      console.error('Error removing item:', error);
    }
  },
};

export function timeoutPromise(ms: number, promise: Promise<any>): Promise<any> {
  // Sample usage: await timeoutPromise(10*60*1000, fetch('/hello'));
  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      reject(new Error("promise timeout"));
    }, ms);
    promise.then(
      (res) => {
        clearTimeout(timeoutId);
        resolve(res);
      },
      (err) => {
        clearTimeout(timeoutId);
        reject(err);
      }
    );
  });
}


/**
 * Debounce function that delays invoking `func` until after `delay` milliseconds 
 * have elapsed since the last time the debounced function was invoked.
 *
 * @param {Function} func - The function to debounce.
 * @param {number} delay - The number of milliseconds to delay.
 *
 * @returns {Function} - Returns a new debounced function.
 *
 * @example
 * // Creates a debounced function that delays invoking `updateWindowSize` 
 * // until after 300 milliseconds have elapsed since the last time 
 * // the debounced function was invoked.
 * const debouncedUpdate = debounce(updateWindowSize, 300);
 *
 * // Invoke the debounced function
 * debouncedUpdate();
 */
export const debounce = (func: (...args: any[]) => void, delay: number): ((...args: any[]) => void) => {
  let timerId: NodeJS.Timeout | null;
  return (...args: any[]): void => {
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(() => {
      func(...args);
      timerId = null;
    }, delay);
  };
};


export function sleep(delay: number) {
  /* Usage: await timeout(1000) */
  return new Promise(res => setTimeout(res, delay));
}

export function deleteLabelsFromNodes(
  nodes: { [id: string]: string[] },
  currentPath: string,
  labelPositions: number[]
) {
  var nodesTmp = { ...nodes };
  
  if (nodesTmp[currentPath]) {
    labelPositions.forEach(position => {
      if (position >= 0 && position < nodesTmp[currentPath].length) {
        delete nodesTmp[currentPath][position];
      }
    });
    nodesTmp[currentPath] = nodesTmp[currentPath].filter(label => label !== undefined);
  }
  
  return nodesTmp;
}




export function updict(dictionary: any, key: string, value: any){
  return {
    ...dictionary,
    [key]: value
  };
}
export function updateDictionaryBulk(input: {[key: string]: string}, keys: string, color: string): {[key: string]: string} {
  const newDict = {...input};
  const keyList = keys.split('\n');
  keyList.forEach(key => {
    if (key.trim().length > 0) {
      newDict[key] = color;
    }
  });
  return newDict;
}


export function delFromDict<T>(dictionary: T, key: keyof T): T {
  const newDictionary = { ...dictionary };
  delete newDictionary[key];
  return newDictionary;

}




/*
export async function store(key:string, obj:any){
  if(_debugMode){console.log("CALLED STORE",key, obj)}
    await Preferences.set({
      key: _preferencesKeyPrefix+key,
      value: JSON.stringify(obj)
    });
}

export async function load(key:string, defaultValue:any){
  if(_debugMode){console.log("CALLED LOAD",key);}
  
  const data = await Preferences.get({ key: _preferencesKeyPrefix+key });

  if(_debugMode){console.log("Loaded data for key ",key,"=", data);}

  let loaded;
  if(!checkIfValidVariable(data.value)){
    loaded = defaultValue;
    if(_debugMode){console.log("Variable with key",key,"is not valid. Setting to default",defaultValue);}
  }else{
    loaded = JSON.parse(data.value || defaultValue) ;
    
  }

  if(_debugMode){console.log("[load:] Loaded",key, loaded);}

  if(key == "nodes" && loaded != null){
    loaded = removeEmptyArrays(loaded, [_rootName]);
  }
  
  return loaded;
}
*/





export async function store(key: string, obj: any) {
  if (_debugMode) {
    console.log("CALLED STORE", key, obj);
  }
  await ionicStorage.set(_preferencesKeyPrefix + key, JSON.stringify(obj));
}

export async function load(key: string, defaultValue: any = undefined) {
  if (_debugMode) {
    console.log("CALLED LOAD", key);
  }

  const data = await ionicStorage.get(_preferencesKeyPrefix + key);

  if (_debugMode) {
    console.log("Loaded data for key ", key, "=", data);
  }

  let loaded;
  if (!checkIfValidVariable(data)) {
    loaded = defaultValue;
    if (_debugMode) {
      console.log("Variable with key", key, "is not valid. Setting to default", defaultValue);
    }
  } else {
    loaded = JSON.parse(data || defaultValue);
  }

  if (_debugMode) {
    console.log("[load:] Loaded", key, loaded);
  }

  if (key == "nodes" && loaded != null) {
    loaded = removeEmptyArrays(loaded, [_rootName]);
  }

  return loaded;
}






export const encryptData = async (text:string,userUniqueId:string | null) => {
  if(userUniqueId === null){return ""}
    const sPass = userUniqueId+"0ösk437%$1!?`*/";
    return CryptoJS.SHA3(sPass+text).toString(CryptoJS.enc.Base64);
  };

export async function goToContacts(lang:string){
    await Browser.open({ url: _dict.contacts[lang] });
}

export async function goToWhatsApp(lang:string){
  await Browser.open({ url: _dict.whatsApp[lang] });
}

export function checkIfValidVariable(variable:any){
  const cond1:boolean = variable != null && variable != undefined && variable != "" && variable != "undefined";
  if(cond1 == false){
    return false;
  }else if(typeof variable == typeof {}){
    if("key" in variable){
      if(variable.key != null && variable.key != undefined && variable.key != ""){
        return true;
      }
      return false;
    }
    return true;
  }else if(cond1 == true){
    return true;
  }
}

export function countNodes(nodes:{ [key: string]: string[] }){
  return Object.entries(nodes).map((v:any[],i) => v[1].length).reduce((p,n) => p+n, 0);
}



/*
export async function showVisibleLabels(parentMode:boolean, nodes:any, path:string){
   let labels = nodes[path] || [];
  if(parentMode==false){
    const vis = await load("visibility", _l2visibility);
    return labels.filter((el:any) => vis[el] !== false);
  }else{
    return labels;
  }
}*/

function removeEmptyArrays(dict: any, keysExceptions: string[]){
  for (const key in dict) {
    if(!keysExceptions.includes(key)){    
      if (Array.isArray(dict[key]) && dict[key].length === 0) {
        delete dict[key];
      }
    }
  }
  return dict;
}

export function addNewLabelToNodes(dict: {[key: string]: string[]}, key: string, label:string): {[key: string]: string[]} {
  let newDict = {...dict};
  let value = label;//_dict.defaultLabel[lang];
  if (newDict.hasOwnProperty(key)){
    newDict[key] = [value, ...newDict[key]];
  }else{
      newDict[key] = [value];
  }
  return newDict;
}

/**
 * Merges two dictionaries with string keys and values that are arrays of strings.
 * If a key is present in both dictionaries, the values are merged into a single array containing the unique values from both dictionaries.
 * If a key is only present in one of the dictionaries, it is added to the result as is.
 * @param dict1 - The first dictionary to merge
 * @param dict2 - The second dictionary to merge
 * @returns A new dictionary containing the merged values from both input dictionaries
 */

/*export function mergeNodes(dict1: {[key: string]: string[]}, dict2: {[key: string]: string[]}) : {[key: string]: string[]} {
  if(_debugMode){console.log("CALLED mergeNodes.")}
  if(_debugMode){console.log("[mergeNodes] dict1 =",dict1)}
  if(_debugMode){console.log("[mergeNodes] dict2 =",dict2)}
  let result: {[key: string]: string[]} = {};
  for (let key in dict1) {
    if (dict2.hasOwnProperty(key)){
      let mergedList = [...dict1[key]];
      for (let item of dict2[key]) {
        if (!mergedList.includes(item)) {
          mergedList.push(item);
        }
      }
      result[key] = mergedList;
    } else {
      result[key] = dict1[key];
    }
  }
  for (let key in dict2) {
    if (!result.hasOwnProperty(key)) {
      result[key] = dict2[key];
    }
  }
  if(_debugMode){console.log("[mergeNodes] result =",result)}
  return result;
}*/

/**
 * Merges two objects containing arrays as values.
 * Keeps all elements from both input arrays, including duplicates within the same array.
 * Only adds elements from the second input array that are not already present in the first input array.
 * @param dict1 - The first input object.
 * @param dict2 - The second input object.
 * @returns A new object containing the merged arrays.
 */
export function mergeNodes(dict1: {[key: string]: string[]}, dict2: {[key: string]: string[]}, allowRepetitions: boolean = false) : {[key: string]: string[]} {
  const result = {...dict1};
  for (const key in dict2) {
      if (result.hasOwnProperty(key)) {
          dict2[key].forEach((value) => {
              if (allowRepetitions || !result[key].includes(value)) {
                  result[key].push(value);
              }
          });
      } else {
          result[key] = [...dict2[key]];
      }
  }
  return result;
}




/**
 * Merges two dictionaries. If a key is present in both dictionaries, the value from the dictionary specified by the priority parameter is used.
 * @param dict1 - The first dictionary to merge
 * @param dict2 - The second dictionary to merge
 * @param priority - The dictionary to prioritize when a key is present in both dictionaries. Should be either 1 or 2.
 * @returns A new dictionary containing the merged values from both input dictionaries
 */

export function mergeDictsWithPriority(dict1: {[key: string]:  any}, dict2: {[key: string]: any}, priority: number) : {[key: string]: any} {
  let result: {[key: string]: {[key: string]: any}} = {...dict1};
  for (let key in dict2) {
    if (!result.hasOwnProperty(key) || priority === 2) {
      result[key] = dict2[key];
    }
  }
  return result;
}  
  
export function mergeVarsWithPriority(var1: string | number | boolean, var2: string | number | boolean, priority: number) : string | number | boolean {
  if(_debugMode){console.log("CALLED mergeVarsWithPriority. Merging var ",var1,"with",var2)}
  let result: string | number | boolean = var1;
  if (priority === 2) {
    result = var2;
  }
  if(_debugMode){console.log("[mergeVarsWithPriority:] Merged result",result)}
  return result;
}


export function containsAllWords(words: string[], text: string): boolean {
  for (const word of words) {
    if (!text.includes(word)) {
      return false;
    }
  }
  return true;
}


export function reorderArray(strArr: string[], initPos: number | null, pos: number | null): string[] {
  if (initPos === null || pos === null) {
      return strArr;
  }
  let strStr = strArr[initPos];
  strArr.splice(initPos, 1);
  strArr.splice(pos, 0, strStr);
  return strArr;
}


export function compressData(data: any): Uint8Array {
  let uint8Array: Uint8Array;
  const jsonString = JSON.stringify(data);
  const compressedData = pako.deflate(jsonString, { level: 9 });
  uint8Array = new Uint8Array(compressedData);
  return uint8Array;
}

export function decompressData(compressedData: Uint8Array): any {
  const decompressedData = pako.inflate(compressedData);
  const jsonString = new TextDecoder().decode(decompressedData);
  const data = JSON.parse(jsonString);
  return data;
}


export function cleanDict2IfNotInDict1(dict1: {[key: string]: string[]}, dict2: {[key: string]: any}): {[key: string]: any} {
  if(_debugMode){console.log("CALLED cleanDict2IfNotInDict1")}
  // Create a set of all values in dict1
  let values = new Set<string>();
  for (let key in dict1) {
      for (let value of dict1[key]) {
          values.add(value);
      }
  }

  // Create a new dictionary with keys from dict2 that are present in values
  let newDict: {[key: string]: any} = {};
  for (let key in dict2) {
      if (values.has(key)) {
          newDict[key] = dict2[key];
      }
  }

  return newDict;
}


function compareTopSentences(a: Array<[string[], number]>, b: Array<[string[], number]>): boolean {
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) {
      if (a[i][1] !== b[i][1]) return false;
      if (a[i][0].length !== b[i][0].length) return false;
      for (let j = 0; j < a[i][0].length; j++) {
          if (a[i][0][j] !== b[i][0][j]) return false;
      }
  }
  return true;
}


//REF-1
export function compareDataDicts(a: DataDict, b: DataDict): boolean {
  // Compare settings
  if(!('settings' in a) || !('settings' in b)) return false;
  if (a.settings !== b.settings) return false;

  // Compare storageSystem
  if (a.storageSystem !== b.storageSystem) return false;

  // Compare nodes
  if (!compareObjects(a.nodes, b.nodes)) return false;

  // Compare l2image
  if (!compareObjects(a.l2image, b.l2image)) return false;

  // Compare l2audio
  if (!compareObjects(a.l2audio, b.l2audio)) return false;

  // Compare l2visibility
  if (!compareObjects(a.l2visibility, b.l2visibility)) return false;

  // Compare l2color
  if (!compareObjects(a.l2color, b.l2color)) return false;

  // Compare topSentences
  if (!compareTopSentences(a.topSentences, b.topSentences)) return false;

  return true;
}

function compareObjects(a: any, b: any): boolean {
  // Check if both objects have the same number of keys
  if (Object.keys(a).length !== Object.keys(b).length) return false;

  // Check if all keys and values are the same
  for (const key in a) {
    if (!(key in b)) return false;
    if (Array.isArray(a[key])) {
      if (!Array.isArray(b[key])) return false;
      if (!compareArrays(a[key], b[key])) return false;
    } else if (typeof a[key] === 'object') {
      if (typeof b[key] !== 'object') return false;
      if (!compareObjects(a[key], b[key])) return false;
    } else {
      if (a[key] !== b[key]) return false;
    }
  }

  return true;
}

/* Check if two arrays are equal or not */
export function compareArrays(a: any[], b: any[]): boolean {
  // Check if both arrays have the same length
  if (a.length !== b.length) return false;

  // Check if all elements are the same
  for (let i = 0; i < a.length; i++) {
    if (Array.isArray(a[i])) {
      if (!Array.isArray(b[i])) return false;
      if (!compareArrays(a[i], b[i])) return false;
    } else if (typeof a[i] === 'object') {
      if (typeof b[i] !== 'object') return false;
      if (!compareObjects(a[i], b[i])) return false;
    } else {
      if (a[i] !== b[i]) return false;
    }
  }

  return true;
}


export function rateLimit<T extends (...args: any[]) => any>(
  fn: T,
  limitCount: number,
  limitInterval: number
): T {
  let count = 0;
  let startTime = Date.now();
  return ((...args: any[]) => {
    const now = Date.now();
    if (now - startTime > limitInterval) {
      count = 0;
      startTime = now;
    }
    if (count < limitCount) {
      count++;
      return fn(...args);
    }else{
      console.log("Too many invokations!")
    }
  }) as T;
}

export async function clearCache() {
  const domain = window.location.hostname;
  
  // Delete all caches
  if ('caches' in window) {
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map(cacheName => caches.delete(cacheName)));
    
  }

  // Delete all stored PWA content
  if ('indexedDB' in window) {
    const databases = await indexedDB.databases();
    const databaseNames = databases
      .filter(database => database.name!.startsWith(domain))
      .map(database => database.name);
    await Promise.all(
      databaseNames
        .filter(databaseName => databaseName !== undefined)
        .map(databaseName => indexedDB.deleteDatabase(databaseName!))
    );
  }
}


export function copyLabelValue(
  prevLabel: string,
  currLabel: string,
  dictionaries: { [key: string]: any }[]
): { [key: string]: any }[] {
  return dictionaries.map((dictionary) => {
    if (prevLabel in dictionary) {
      dictionary[currLabel] = dictionary[prevLabel];
    }
    return dictionary;
  });
}


/**
 * Removes the last element from a list of strings if the last two elements have already occurred in the same sequence earlier in the list.
 * @param strings - The input list of strings.
 * @returns A new list of strings with the last element removed if the last two elements have already occurred in the same sequence earlier in the list. Otherwise, returns the input list unchanged.
 */
function removeLastIfRepeatedSequence(strings: string[]): string[] {
  if (strings.length < 2) return strings;
  const last = strings[strings.length - 1];
  const secondLast = strings[strings.length - 2];
  for (let i = 0; i < strings.length - 2; i++) {
      if (strings[i] === secondLast && strings[i + 1] === last) {
          strings.pop();
          break;
      }
  }
  return strings;
}

export function checkSentenceRules(sentence: string[] | null, nodes:any) {
  if(sentence === null){
    return null;
  }

  if(sentence.length > _maxSentenceLen){
    return sentence.slice(0, _maxSentenceLen);
  }

  let result: string[] = [];
  for (let i = 0; i < sentence.length; i++) {
    if (i === 0 || sentence[i] !== sentence[i - 1]) {
      result.push(sentence[i]);
    }
  }

  result = removeLastIfRepeatedSequence(result);

  // Respect labels hierarchy
  const previousLabelHierarchyLevel = findLowestLevel(nodes, sentence[sentence.length-2]);  
  const currentLabelHierarchyLevel = findLowestLevel(nodes, sentence[sentence.length-1]);

  if(sentence.length > 1 && currentLabelHierarchyLevel < previousLabelHierarchyLevel){
    result = result.slice(0, -1);
  }


  return result;
}


function limitSentenceCounter(topSentences: Array<[string[], number]>){
  if (topSentences[0][1] > 1000000) {
    topSentences[0][1] = 1000000
  }
}

/**
 * Updates the topSentences array by searching for a given sentence.
 * If the sentence is not found, it is appended to topSentences along with the number 1.
 * If the sentence is found, the existing number is increased by 1.
 * Afterwards, topSentences is sorted by increasing numbers.
 * For equal numbers, their relative order respects their previously existing precedence.
 *
 * @param topSentences - An array of tuples representing the top sentences and their counts
 * @param sentence - The sentence to search for and update in topSentences
 */
export function updateTopSentences(topSentences: Array<[string[], number]>, sentence: string[]){
  let found = false;
  for (let i = 0; i < topSentences.length; i++) {
      if (topSentences[i][0].toString() === sentence.toString()) {
          topSentences[i][1]++;
          found = true;
          break;
      }
  }
  if (!found) {
      topSentences.push([sentence, 1]);
  }
  topSentences.sort((a, b) => b[1]-a[1]);


  // Calculate the floor of the median value
  const medianIndex = Math.floor(topSentences.length / 2);
  let medianValue = topSentences[medianIndex][1];
  if (topSentences.length % 2 === 0) {
    medianValue = (topSentences[medianIndex - 1][1] + topSentences[medianIndex][1]) / 2;
  }
  const floorOfMedianValue = Math.floor(medianValue);

  // Subtract the floor of the median value from each number
  for (let i = 0; i < topSentences.length; i++) {
    topSentences[i][1] -= floorOfMedianValue;
  }

  limitSentenceCounter(topSentences);
  return topSentences;
}


/**
 * Filters an array of arrays of strings to only include those elements that contain all the strings from a given array of strings.
 *
 * @param strings - An array of strings to filter by.
 * @param lists - An array of arrays of strings to filter.
 * @returns A new array containing only those elements from the `lists` array that contain all the strings from the `strings` array.
 */
export function filterStrings(
  strings: string[],
  lists: string[][]
): string[][] {
  return lists.filter(list => strings.every(str => list.includes(str)));
}


export function deleteEmptyStrings(strings: string[]): string[] {
  return strings
    .map(str => str.trim())
    .map(str => str.replace(/\s+/g, ' '))
    .filter(str => str !== '');
}

export function getSentenceType(file: string): string {
  if (file.startsWith('sentences')) {
      return 'sentence';
  } else if (file.endsWith('words')) {
      return 'word';
  } else {
      return 'word';
  }

}

/* Turns a list of sentences into a nodes dictionary for cards */
export function sentencesToDict(
  sentences: string[],
  minWordChars: number,
  baseLevel: string = _rootName
): { [key: string]: string[] } {
  const result: { [key: string]: string[] } = { [baseLevel]: [] };
  for (const sentence of sentences) {
    let level = baseLevel;
    let currentSentence = sentence;
    while (currentSentence.length > 0) {
      let nextLevel = '';
      let nextSentence = '';
      let index = 0;
      while (index < currentSentence.length) {
        const wordEndIndex = currentSentence.indexOf(' ', index);
        const word =
          wordEndIndex === -1
            ? currentSentence.slice(index)
            : currentSentence.slice(index, wordEndIndex);
        nextLevel += (nextLevel.length > 0 ? ' ' : '') + word;
        index += word.length + 1;
        if (word.length >= minWordChars) {
          break;
        }
      }
      nextSentence = currentSentence.slice(index).trim();
      if (!result[level]) {
        result[level] = [];
      }
      if (!result[level].includes(nextLevel)) {
        result[level].push(nextLevel);
      }
      level += '.' + nextLevel;
      currentSentence = nextSentence;
    }
  }
  return result;
}


export function dictToSentences(dict: { [key: string]: string[] }, baseLevel:string): string[] {
  const result: string[] = [];
  const stack: { level: string; sentence: string }[] = [{ level: baseLevel, sentence: '' }];
  while (stack.length > 0) {
    const { level, sentence } = stack.pop()!;
    if (dict[level]) {
      for (const nextLevel of dict[level]) {
        stack.push({
          level: level + '.' + nextLevel,
          sentence: sentence + (sentence.length > 0 ? ' ' : '') + nextLevel,
        });
      }
    } else {
      result.push(sentence);
    }
  }
  return result;
}

export function nodesToUniqueStrings(
  nodes: { [key: string]: string[] },
  excludeCondition?: (value: string) => boolean
): string[] {
  let result: string[] = [];
  for (let key in nodes) {
    if (excludeCondition) {
      result = [
        ...result,
        ...nodes[key].filter((value) => !excludeCondition(value)),
      ];
    } else {
      result = [...result, ...nodes[key]];
    }
  }
  return [...new Set(result)];
}

// Iterate over all nodes and if a value in values list starts with given prefix, add to results
export function getLabelsStartingWith(nodes: { [key: string]: string[] }, prefix: string): string[] {
  let results: string[] = [];
  for (let key in nodes) {
    for (let value of nodes[key]) {
      if (value.startsWith(prefix)) {
        results.push(value);
      }
    }
  }
  return results;
}

// Get next alias for a label
export function getProperSuffixDict(nodes: { [key: string]: string[] }, labels: string[]): { [key: string]: string } {
  // This function maps a label to its suffix
  
  const suffixDict: { [key: string]: string } = {};

  for (let label of labels) {
    let alias = label.replaceAll(_ALIAS_SUFFIX, "");
    let suffix = "";
    const filteredValues = getLabelsStartingWith(nodes, alias);
    while (filteredValues.includes(alias)) {
      alias = alias + _ALIAS_SUFFIX;
      suffix = suffix + _ALIAS_SUFFIX;
    }
    suffixDict[label] = suffix;
  }

  

  return suffixDict;
}



/**
 * This function reorders an array of unique strings
 * based on the length of keys in nodes.
 * The idea is that for progressive rendering,
 * the cards that are first visible to the user should be
 * prioritized for loading.
 * 
**/
export function reorderStringsBasedOnFirstAppearance(
  nodes: { [key: string]: string[] },
  uniqueStrings: string[]
): string[] {
  // Create an array of keys sorted by length
  let keysSortedByLength = Object.keys(nodes).sort((a, b) => a.length - b.length);

  // Create a new array to hold the reordered strings
  let reorderedStrings: string[] = [];

  // Iterate over the sorted keys
  for (let key of keysSortedByLength) {
    // Find the strings in uniqueStrings that are in nodes[key]
    let stringsForKey = uniqueStrings.filter((str) => nodes[key].includes(str));

    // Append these strings to reorderedStrings
    reorderedStrings = [...reorderedStrings, ...stringsForKey];

    // Remove these strings from uniqueStrings
    uniqueStrings = uniqueStrings.filter((str) => !stringsForKey.includes(str));
  }

  // Append any remaining strings in uniqueStrings to reorderedStrings
  reorderedStrings = [...reorderedStrings, ...uniqueStrings];

  return reorderedStrings;
}



async function resizeImage(base64: string, maxWidth: number, maxHeight: number): Promise<string> {
  // Create an image element
  const img = document.createElement('img');
  img.src = base64;

  // Wait for the image to load
  await new Promise(resolve => { img.onload = resolve; });

  // Calculate the new dimensions
  let width = img.width;
  let height = img.height;
  if (width > maxWidth) {
      height *= maxWidth / width;
      width = maxWidth;
  }
  if (height > maxHeight) {
      width *= maxHeight / height;
      height = maxHeight;
  }

  // Create a canvas element
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  // Draw the image onto the canvas
  const ctx = canvas.getContext('2d');
  ctx?.drawImage(img, 0, 0, width, height);

  // Return the resized image as a base64 string
  return canvas.toDataURL();
}

export function delay(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}




export async function getArasaacImages(
  lang: string,
  word: string | null,
  maximumImages: number = 1): Promise<(string | null)[]> {
    if(word == null) return [null];


  // If the word is a new line, return an empty array
  if(word.startsWith(_NEW_LINE) || word == ""){
    return Promise.resolve([null]);
  }

  // If not on localhost and until date, gather words statistics for Firebase
  if (window.location.hostname !== 'localhost') {
    const today = new Date();
    const year = today.getFullYear();
    const februaryEnd = new Date(year, 5, 30); // 30th of June

    if (today <= februaryEnd){
      addOrUpdateWord(word);
    }
  }  
  
  let response, arasaac_img_id, data, img_base64;
  
  try{
    // Calling RP server
    response = await await timeoutPromise(
      3*1000,
      fetch(`${_SERVER_URL_RP}/getimg/${lang}/${word}`)
    );

    arasaac_img_id = (await response.json()).id;
    // Get base64 image from URL:
    img_base64 = await getBase64FromURL(`${_SERVER_URL_IMAGES_1}/ARASAAC/${arasaac_img_id}.png`);
    return [img_base64];
  }catch(error){
    // RP server is not reachable, try ARASAAC
    console.log("RP server is not reachable, trying ARASAAC");
    try {
      response = await fetch(`https://api.arasaac.org/api/pictograms/${lang}/search/${processStringForArasaacSearch(word)}`);
      data = await response.json();
      const results: (string | null)[] = [];
      for (let i = 0; i < Math.min(maximumImages, data.length); i++) {
        const imageId = data[i]._id;
        const imageResponse = await fetch(`https://static.arasaac.org/pictograms/${imageId}/${imageId}_500.png`);
        let blob: Blob;
        try {
          blob = await imageResponse.blob();
        } catch (error) {
          results.push(null);
          continue;
        }
        results.push(await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result as string);
          reader.readAsDataURL(blob);
        }));
        await delay(100); // Add a delay of 100 milliseconds between calls
      }
      return results;
    } catch (error) {
      return Promise.resolve([null]);
    }
  }
  
  
  


  
  
}




export function checkIfSentenceHasAudio(sentence: string[], l2audio: {[key: string]: any}): boolean {
  for (let word of sentence) {
      if (!(word in l2audio)) {
          return false;
      }
  }
  return true;
}

export function pickRandomElement(input: any[]): any {
  let randomIndex = Math.floor(Math.random() * input.length);
  return input[randomIndex];
}


/*



async function generateImage(inputText: string): Promise<string> {
  const clientOptions = {
    apiEndpoint: `${location}-aiplatform.googleapis.com`,
  };

  const pipelineServiceClient = new google.cloud.aiplatform.v1.PipelineServiceClient(
    clientOptions
  );

  const modelPath = `projects/${projectId}/locations/${location}/models/${modelId}`;

  const instance = {
    textSnippet: {
      content: inputText,
      mimeType: 'text/plain',
    },
  };

  const input = {
    instances: [instance],
  };

  const [response] = await pipelineServiceClient.predict({
    endpoint: modelPath,
    instances: input.instances,
  });

  const imageBytes = response.predictions[0].imageBytes;
  const imageBuffer = Buffer.from(imageBytes, 'base64');
  return imageBuffer.toString('base64');
}*/



/*
function getSimilarity(a: string, b: string): number {
  return stringSimilarity.compareTwoStrings(a, b);
}

export async function getLineFromFile(lineNumber: number, language: string): Promise<string> {
  const response = await fetch('data/words_'+language+'.txt');
  const data = await response.text();
  const lines = data.split('\n');
  return lines[lineNumber];
}

export async function findMostSimilarRow(input: string, language: string): Promise<number> {
  const response = await fetch('data/words_'+language+'.txt');
  const data = await response.text();
  const rows = data.split('\n');
  let mostSimilarRow = 0;
  let highestSimilarity = 0;
  for (let i = 0; i < rows.length; i++) {
    const words = rows[i].split(',');
    for (const word of words) {
      const similarity = getSimilarity(input.toLowerCase(), word.toLowerCase());
      if (similarity > highestSimilarity) {
        highestSimilarity = similarity;
        mostSimilarRow = i;
      }
    }
  }
  
  if(highestSimilarity > 0.49){return mostSimilarRow;}
  return -1;
}
*/

/*
async function textToSpeechBase64(text: string): Promise<string> {
  const client = new TextToSpeechClient();
  const request = {
    input: { text },
    voice: { languageCode: 'en-US', ssmlGender: 'NEUTRAL' },
    audioConfig: { audioEncoding: 'MP3' },
  };
  const [response] = await client.synthesizeSpeech(request);
  return response.audioContent.toString('base64');
}

*/



/*
export async function textToSpeech(text: string, firebaseConfig: any) {
  const uri = `https://texttospeech.googleapis.com/v1/text:synthesize?key=${firebaseConfig.apiKey}`;
  const options = {
    method: 'POST',
    uri,
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      input: { text },
      voice: { languageCode: 'en-US', ssmlGender: 'NEUTRAL' },
      audioConfig: { audioEncoding: 'MP3' },
    }),
  };

  return new Promise((resolve, reject) => {
    request(options, (error, response, body) => {
      if (error) {
        reject(error);
      } else {
        resolve(JSON.parse(body).audioContent);
      }
    });
  });
}*/


/* Normalize string to be associated with images */
export function normalizeString(str: string): string {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9]/g, '')
    .toLowerCase();
}


async function addCardTitleToImagesDictFromArasaacIfNotExisting(
  userUniqueId: string,
  userEmail: string,
  l2image: { [key: string]: string },
  cardTitle: string,
  lang: string,
  resetImage: boolean,
  cachedLocalAutoL2image: { [key: string]: string[] },
  setL2Image: any

) {

  let newL2Image = { ...l2image };
  let newCachedLocalAutoL2image = { ...cachedLocalAutoL2image};
  const cardTitleNorm = normalizeString(cardTitle);

  if (!newL2Image.hasOwnProperty(cardTitle) && newCachedLocalAutoL2image.hasOwnProperty(cardTitleNorm) && resetImage === false) {
    newL2Image[cardTitle] = newCachedLocalAutoL2image[cardTitleNorm][0];
  } else if (!newL2Image.hasOwnProperty(cardTitle) || newL2Image[cardTitle]?.length < 10 || resetImage === true) {

    // Check first if image is available from Firebase Storage
    const found = await checkRemoteObject(userUniqueId, userEmail, remoteSharedLocation, cardTitleNorm);
    if(found){
      const obj  = await downObject(userUniqueId, userEmail, remoteSharedLocation, cardTitleNorm);
      if(obj !== false){
        newCachedLocalAutoL2image[cardTitleNorm] = obj as string[];
      }
      if (newCachedLocalAutoL2image[cardTitleNorm].length > 0) {
        newL2Image[cardTitle] = newCachedLocalAutoL2image[cardTitleNorm][0];
      }

    }else{ // if not found, get it from Arasaac and update cachedDit
      let imagesFromArasaac = await getArasaacImages(lang, cardTitle);
      newCachedLocalAutoL2image[cardTitleNorm] = [];
      for (const imageFromArasaac of imagesFromArasaac) {
        if (imageFromArasaac !== null) {
          let base64ReducedFromArasaac = await resizeImage(imageFromArasaac, 300, 300);
          newCachedLocalAutoL2image[cardTitleNorm] = [...newCachedLocalAutoL2image[cardTitleNorm], base64ReducedFromArasaac] 
        }
      }
      
      if (newCachedLocalAutoL2image[cardTitleNorm].length > 0) {
        // console.log("newCachedLocalAutoL2image has length > 0")
        // if cachedDict has data, update newL2Image and upload data to Firebase Storage
        newL2Image[cardTitle] = newCachedLocalAutoL2image[cardTitleNorm][0];
        upObject(newCachedLocalAutoL2image[cardTitleNorm], userUniqueId, userEmail, remoteSharedLocation, cardTitleNorm);
      }else{
        // REF-123 Handle the case where it is not foud on Firebase and also not on Arasaac
        await addWord(cardTitleNorm);


      }
    }
  }
  //store("cachedLocalAutoL2image", cachedDict);
  setL2Image(newL2Image); // in order to show user progress, not just at the end
  return { newL2Image, newCachedLocalAutoL2image };
}

/*
export async function addCardTitleToImagesDictFromArasaacIfNotExistingBulk(
  userUniqueId: string,
  userEmail: string,
  l2image: { [key: string]: string },
  cardTitles: string[],
  lang: string,
  resetImage: boolean,
  cachedLocalAutoL2image: { [key: string]: string[] },
  setL2Image: any
) {

  let newL2Image = { ...l2image };
  let newCachedLocalAutoL2image = { ...cachedLocalAutoL2image};


  // because of the translateToIT pre-processing, lang input parameter will be ignored
  //let language = lang;  
  //let language = "it"; 
  
  //const cardTitlesTranslated = await Promise.all(cardTitles.map(async (cardTitle) => await translateToIT(cardTitle)));

  //let cardTitlesList = cardTitles;
  //const cardTitlesNorm = cardTitlesTranslated.map(normalizeString);  
  const cardTitlesNorm = cardTitles.map(normalizeString);  

  const foundObjects = await Promise.all(cardTitles.map(async (cardTitle, i) => {
    if (!newCachedLocalAutoL2image.hasOwnProperty(cardTitle)) {
      try {
        const objRef = ref(firebaseStorage, remoteSharedLocation+"/"+cardTitlesNorm[i]);
        var blob = await (await getBlob(objRef));
        return decompressData(new Uint8Array(await new Response(blob).arrayBuffer()));
      } catch (error) {
        return false;
      }
    } else {
      return false;
    }
  }));
  

  for (let i = 0; i < cardTitles.length; i++) {
    const cardTitle = cardTitles[i].trim();
    if (cardTitle.length > 0) {
      if (!newL2Image.hasOwnProperty(cardTitle) && newCachedLocalAutoL2image.hasOwnProperty(cardTitlesNorm[i]) && resetImage === false) {
        newL2Image[cardTitle] = newCachedLocalAutoL2image[cardTitlesNorm[i]][0];
      } else if (!newL2Image.hasOwnProperty(cardTitle) || newL2Image[cardTitle]?.length < 10 || resetImage === true) {
        if(foundObjects[i]){
          newCachedLocalAutoL2image[cardTitlesNorm[i]] = foundObjects[i] as string[];
        }else{
          let imagesFromArasaac = await getArasaacImages(lang, cardTitle);
          newCachedLocalAutoL2image[cardTitlesNorm[i]] = [];
          for (const imageFromArasaac of imagesFromArasaac) {
            if (imageFromArasaac !== null) {
              let base64ReducedFromArasaac = await resizeImage(imageFromArasaac, 300, 300);
              newCachedLocalAutoL2image[cardTitlesNorm[i]] = [...newCachedLocalAutoL2image[cardTitlesNorm[i]], base64ReducedFromArasaac] 
            }
          }
        }
        if (newCachedLocalAutoL2image[cardTitlesNorm[i]].length > 0) {
          newL2Image[cardTitle] = newCachedLocalAutoL2image[cardTitlesNorm[i]][0];
          setL2Image(newL2Image); // in order to show user progress, not just at the end
          upObject(newCachedLocalAutoL2image[cardTitlesNorm[i]], userUniqueId, userEmail, remoteSharedLocation, cardTitlesNorm[i]);
        }else{
          await addWord(cardTitlesNorm[i]);
        }
      }
    }
  }
  return { newL2Image, newCachedLocalAutoL2image };
}*/

export async function addCardTitleToImagesDictFromArasaacIfNotExistingBulk(
  userUniqueId: string | null,
  userEmail: string | null,
  l2image: { [key: string]: string },
  cardTitles: string[],
  lang: string,
  resetImage: boolean,
  cachedLocalAutoL2image: { [key: string]: string[] }
) {
  if(userUniqueId === null || userEmail === null){
    return { newL2Image: l2image, newCachedLocalAutoL2image: cachedLocalAutoL2image };
  }
  let newL2Image = { ...l2image };
  let newCachedLocalAutoL2image = { ...cachedLocalAutoL2image};

  const cardTitlesNorm = cardTitles.map(normalizeString);  

  const foundObjects = await Promise.all(cardTitles.map(async (cardTitle, i) => {
    if (!newCachedLocalAutoL2image.hasOwnProperty(cardTitle)) {
      try {
        const objRef = ref(firebaseStorage, remoteSharedLocation+"/"+cardTitlesNorm[i]);
        var blob = await (await getBlob(objRef));
        return decompressData(new Uint8Array(await new Response(blob).arrayBuffer()));
      } catch (error) {
        return false;
      }
    } else {
      return false;
    }
  }));

  // to update FIREBASE 
  const uploadPromises = [];

  for (let i = 0; i < cardTitles.length; i++) {
    
    const cardTitle = cardTitles[i].trim();
    if (cardTitle.length > 0) {
      if (!newL2Image.hasOwnProperty(cardTitle) && newCachedLocalAutoL2image.hasOwnProperty(cardTitlesNorm[i]) && resetImage === false) {
        newL2Image[cardTitle] = newCachedLocalAutoL2image[cardTitlesNorm[i]][0];
      } else if (!newL2Image.hasOwnProperty(cardTitle) || newL2Image[cardTitle]?.length < 10 || resetImage === true) {
        
        if(foundObjects[i]){
          newCachedLocalAutoL2image[cardTitlesNorm[i]] = foundObjects[i] as string[];
        }else{
          let imagesFromArasaac = await getArasaacImages(lang, cardTitle);
          newCachedLocalAutoL2image[cardTitlesNorm[i]] = [];
          for (const imageFromArasaac of imagesFromArasaac) {
            if (imageFromArasaac !== null) {
              let base64ReducedFromArasaac = await resizeImage(imageFromArasaac, 300, 300);
              newCachedLocalAutoL2image[cardTitlesNorm[i]] = [...newCachedLocalAutoL2image[cardTitlesNorm[i]], base64ReducedFromArasaac] 
            }
          }
        }
        if (newCachedLocalAutoL2image[cardTitlesNorm[i]].length > 0) {
          newL2Image[cardTitle] = newCachedLocalAutoL2image[cardTitlesNorm[i]][0];

          // to update FIREBASE 
          uploadPromises.push(upObject(newCachedLocalAutoL2image[cardTitlesNorm[i]], userUniqueId, userEmail, remoteSharedLocation, cardTitlesNorm[i]));
        }else{

          await addWord(cardTitlesNorm[i]);
        }
      }
    }
  }
  
  // to update FIREBASE 
  Promise.allSettled(uploadPromises);

  return { newL2Image, newCachedLocalAutoL2image };
}






/*
export async function addCardTitleToImagesDictFromArasaacIfNotExistingBulk(
  userUniqueId: string,
  userEmail: string,
  l2image: { [key: string]: string },
  cardTitles: string[],
  lang: string,
  resetImage: boolean,
  cachedLocalAutoL2image: { [key: string]: string[] },
  setL2Image: any
) {
  let newL2Image = { ...l2image };
  let newCachedLocalAutoL2image = { ...cachedLocalAutoL2image};
  for (const cardTitle of cardTitles) {
    if (cardTitle.trim().length > 0) {
      
      //assign results from addCardTitleToImagesDictFromArasaacIfNotExisting to newDict and cachedDict
      ({ newL2Image: newL2Image, newCachedLocalAutoL2image: newCachedLocalAutoL2image } = await addCardTitleToImagesDictFromArasaacIfNotExisting(
        userUniqueId,
        userEmail,
        newL2Image,
        cardTitle,
        lang,
        resetImage,
        newCachedLocalAutoL2image,
        setL2Image
      ));
      
    }
  }

  return { newL2Image, newCachedLocalAutoL2image };
}
*/



/*
export async function addCardTitleToImagesDictFromArasaacIfNotExistingBulk(
  input: { [key: string]: string },
  keys: string,
  lang: string,
  resetImage: boolean
): Promise<{ [key: string]: string }> {
  const newDict = { ...input };
  const keyList = keys.split('\n');
  let cachedDict = await load("cachedLocalAutoL2image", _cachedLocalAutoL2image);

  for (const key of keyList) {
    if (key.trim().length > 0) {
      const cardTitleNorm = normalizeString(key);

      if (!newDict.hasOwnProperty(key) && cachedDict.hasOwnProperty(cardTitleNorm) && resetImage === false) {
        newDict[key] = cachedDict[cardTitleNorm][0];
      } else if (!newDict.hasOwnProperty(key) || newDict[key]?.length < 10 || resetImage === true) {
        let imagesFromArasaac = await getArasaacImages(lang, key);
        cachedDict[cardTitleNorm] = [];
        for (const imageFromArasaac of imagesFromArasaac) {
          if (imageFromArasaac != null) {
            let base64ReducedFromArasaac = await resizeImage(imageFromArasaac, 300, 300);
            cachedDict[cardTitleNorm].push(base64ReducedFromArasaac);
          }
        }
        if (cachedDict[cardTitleNorm].length > 0) {
          newDict[key] = cachedDict[cardTitleNorm][0];
        }
      }
    }
  }
  store("cachedLocalAutoL2image", cachedDict);
  return newDict;
}
*/










export function reportCellValueToDisplay(row: { [key: string]: any}, column: string, lang:string, format:string){
  if(column === 'timestamp' || column === 'startDate' || column === 'endDate'){
    if(format === 'csv'){
      return  new Date(row[column]).toLocaleString().replace(',',' ');
    }else{
      return  new Date(row[column]).toLocaleString();
    }
  }else if(column === 'isRight' && ["yes","no"].includes(row[column])){
    return _dict[row[column]][lang]
  }else if(column === 'questionType' && ["text","image"].includes(row[column])){
    return _dict[row[column]][lang]
  }else if(Array.isArray(row[column]) && format==="csv"){
    return row[column].join(' - ')
  }else if(Array.isArray(row[column]) && format==="xlsx"){
    return row[column].join(' - ')
  }
  return row[column]
}


export const handleDownload = (fileType:string, prefixName:string, data:any, lang:string) => {
  // Extract the column headers
  const headers = Object.keys(data[0]);

  if (fileType === 'csv') {
    // Convert the table data to CSV format
    const rows = data.map((row:any) =>
      headers
        .map((header) => {
          const cellValue =  reportCellValueToDisplay(row,header,lang,"csv");
          return Array.isArray(cellValue) ? cellValue.join('; ') : cellValue;
        })
        .join(',')
    );
    const csvData = [headers.map((header) => _dict[header][lang]).join(','), ...rows].join('\n');

    // Create a Blob object from the CSV data
    const blob = new Blob([csvData], { type: 'text/csv' });

    // Create a URL for the Blob object
    const url = URL.createObjectURL(blob);

    // Create a temporary link element
    const link = document.createElement('a');
    link.href = url;

    // Set the download attribute to include the current date as a suffix
    const date = new Date();
    const dateString = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    link.download = `${prefixName}-${dateString}.csv`;

    // Append the link to the document and click it to start the download
    document.body.appendChild(link);
    link.click();

    // Remove the link from the document
    document.body.removeChild(link);
  } else if (fileType === 'xlsx') {
    // Convert the table data to an array of arrays
    const tableData = [
      headers.map((header) => _dict[header][lang]),
      ...data.map((row:any) =>
        headers.map((header) => {
          const cellValue = reportCellValueToDisplay(row,header,lang,"xlsx");
          return Array.isArray(cellValue) ? `(${cellValue.join(' - ')})` : cellValue;
        })
      )
    ];

    // Create a new worksheet from the data
    const worksheet = XLSX.utils.aoa_to_sheet(tableData);

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet);

    // Set the download attribute to include the current date as a suffix
    const date = new Date();
    const dateString = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;

    // Write the workbook to a file and trigger the download
    XLSX.writeFile(workbook, `${prefixName}-${dateString}.xlsx`);
  }
};


export const downloadButtonStyle = () => {
  return { backgroundColor: '#007ea7', color: 'white', fontSize: '14px', padding: '10px 20px', borderRadius: '10px', margin:'5px' }
}

export function findLowestLevel(nodes: {[key: string]: any[]}, label: string): number {
  let lowestLevel = Infinity;
  for (const key in nodes) {
      const levels = key.split('.');
      const level = levels.indexOf(label);
      if (level !== -1 && level < lowestLevel) {
          lowestLevel = level;
      }
      if (nodes[key].includes(label)) {
          const valueLevel = levels.length;
          if (valueLevel < lowestLevel) {
              lowestLevel = valueLevel;
          }
      }
  }
  return lowestLevel === Infinity ? -1 : lowestLevel;
}

/* It changes / manipulate the input string to be better adapted to the Arasaac search */
function processStringForArasaacSearch(input: string): string {
  let result;
  const words = input.split(' ');

  const longWords = words.filter(word => (word.length > 2 || ["no"].includes(word.toLocaleLowerCase())));
  /* Reminder:
  "non sto bene"
  
  */

  if (longWords.length > 0) {
    result = longWords.join(' ');
  }else{
    result = input;
  }

  let fixedMapping: { [key:string]: string }  = _fixedMappingDict;


  let lowerResult = result.toLocaleLowerCase();
  if(fixedMapping.hasOwnProperty(lowerResult)){
    result = fixedMapping[lowerResult];
  }

  //Replace l' with nothing
  result = result.replace("l'","");
  result = result.replace("the","");

  return result;
}

export function limitNodes(dict: {[key: string]: any}, upperLimit: number): {[key: string]: any} {
  let result: {[key: string]: any} = {};
  let count = 0;
  for (let key in dict) {
      if (Array.isArray(dict[key])) {
          result[key] = dict[key].slice(0, upperLimit - count);
          count += result[key].length;
      } else {
          result[key] = dict[key];
      }
      if (count >= upperLimit) break;
  }
  return result;
}

export function getSavedListsFromNodes(nodes: { [key: string]: any }): string[] {
  return Object.keys(nodes).filter((key) => key.includes(_rootName+_pathSeparator+_libName) && key.split(_pathSeparator).length > 2 ).map((key) => key.split(_pathSeparator)[2]);
}

function deleteEmptyLists(
  nodes: { [key: string]: any },
  inputKey: string,
  list: string[]
): { [key: string]: any } {
  const newNodes = { ...nodes };
  for (let i = 0; i < list.length; i++) {
    const key = inputKey + "." + list[i];
    if (Array.isArray(newNodes[key]) && newNodes[key].length === 0) {
      list.splice(i, 1);
      i--;
    } else if (newNodes[key] === undefined) {
      list.splice(i, 1);
      i--;
    }
  }
  return newNodes;
}



function deleteIdenticalLists(
  nodes: { [key: string]: string[] },
  key: string
): { [key: string]: string[] } {
  let newNodes = { ...nodes };
  const value = newNodes[key];
  for (const k in newNodes) {
    if (k.includes(_libName) && k !== key && compareArrays(newNodes[k], value)) {
      delete newNodes[k];
    }
  }
  // Now the lists elements are deleted, but we still have the main "list of lists" where
  // the corresponding elements (list names) must also be deleted.
  // This can be done by using deleteEmptyLists
  let listKey = _rootName+_pathSeparator+_libName;
  newNodes = deleteEmptyLists(newNodes, listKey,  newNodes[listKey]);
  return newNodes;
}



export function addCardsToSavedLists(nodes:any, listName:string, cards:string[], setNodes:any){
  let newLists = [...getSavedListsFromNodes(nodes)];
  if (!newLists.includes(listName)) {
    newLists.push(listName);
  }
  let listKey = _rootName+_pathSeparator+_libName+_pathSeparator+listName;
  let newNodes = updict(nodes,_rootName+_pathSeparator+_libName,newLists);
  newNodes = updict(newNodes,listKey,cards);
  newNodes = deleteIdenticalLists(newNodes, listKey);
  setNodes(newNodes);
}

export function getSavedListName(nodes: { [key: string]: any }, savedList: string[]){
  return Object.keys(nodes).find(
    (key) => key.includes(_libName) && compareArrays(nodes[key], savedList)
  )?.split(_pathSeparator)[2];
}


export function addToListInNodes(
  nodes: { [key: string]: any},
  path: string,
  values?: string[]
): { [key: string]: any} {
  // Create a copy of the input dictionary
  const result = { ...nodes };

  // Check if the input list is valid
  if (values && Array.isArray(values) && values.length > 0) {
    // Check if the path exists in the dictionary and if it points to an array
    if (path in result && Array.isArray(result[path])) {
      // Remove existing duplicate values
      result[path] = [...new Set(result[path])];

      // Add the new values to the existing array, excluding duplicates
      const uniqueValues = values.filter(
        (value) => !result[path].includes(value)
      );
      result[path].push(...uniqueValues);
    } else {
      // Set the value at the given path to the input list
      result[path] = values;
    }
  }

  return result;
}


export function updateVisitedPaths(paths: string[], node: string): string[] {
  // Create a copy of the paths array
  const modifiedPaths = [...paths];

  // Find the index of the first occurrence of node in the paths array
  const index = modifiedPaths.indexOf(node);
  if (index !== -1) {
    // If node is already present in the paths array, remove all elements after it
    modifiedPaths.splice(index + 1);
  } else {
    // If node is not present in the paths array, append it to the end
    modifiedPaths.push(node);
  }

  return modifiedPaths;
}



export function deleteFromDictionary(dictionary: any, key: string) {
  const newDictionary = { ...dictionary };
  delete newDictionary[key];
  return newDictionary;
}


export function updateSimpleDictForKeys
(
  simpleDict: { [key:string] : any},
  keys: string[],
  setSimpleDict: any,
  value:any,
)
{
  let updatedSimpleDict = { ...simpleDict };
  keys.forEach(label => {
    updatedSimpleDict = updict(updatedSimpleDict, label, value);
  });
  setSimpleDict(updatedSimpleDict);
}


export function removeNonStringValuesFromDict(dict: {[key: string]: any}): {[key: string]: string} {
  const output: {[key: string]: string} = {};
  for (const key in dict) {
    if (typeof dict[key] === 'string') {
      output[key] = dict[key];
    }
  }
  return output;
}





export function moveSublist(
  list: string[],
  sublist: string[],
  position: number
): string[] {
  // Create a copy of the original list
  const newList = [...list];

  // Remove elements of sublist from newList
  sublist.forEach((item) => {
    const index = newList.indexOf(item);
    if (index !== -1) {
      newList.splice(index, 1);
    }
  });

  // Insert elements of sublist at specified position
  newList.splice(position, 0, ...sublist);

  return newList;
}

export function copySublistToPositions(
  list: string[],
  sublist: string[],
  positions: number[]
): string[] {
  // Create a copy of the original list
  const newList = [...list];

  // Sort positions in ascending order to handle adjustments correctly
  let sortedPositions = positions.sort((a, b) => a - b);

  const elementsNr = sublist.length;
  sortedPositions = sortedPositions.map((position, idx) => position+idx*elementsNr);
  // Iterate over positions and insert a copy of the sublist at each position
  sortedPositions.forEach((originalPosition) => {
    newList.splice(originalPosition, 0, ...sublist.map(item => item));
  });

  return newList;
}






export function cleanNodes(
  nodes: { [key: string]: string[] },
  exceptions: string[]
): { [key: string]: string[] } {
  // Create a copy of the original nodes dictionary
  const newNodes: { [key: string]: string[] } = { ...nodes };

  // Iterate over the keys of the nodes object
  for (const key in newNodes) {
    // Check if the key is not in the exceptions list
    if (!exceptions.includes(key)) {
      // Split the key into parts
      const parts = key.split('.');

      // Check if the key has more than one part
      if (parts.length > 1) {
        // Get the parent key
        const parentKey = parts.slice(0, -1).join('.');

        // Check if the parent key exists in the nodes object
        if (newNodes[parentKey]) {
          // Check if the last part of the key is in the parent's value array
          if (!newNodes[parentKey].includes(parts[parts.length - 1])) {
            // Delete the orphan entry
            delete newNodes[key];
          }
        } else {
          // Delete the orphan entry
          delete newNodes[key];
        }
      }
    }

    // Delete all entries that do not start with "root." or are not exactly "root"
    if (!key.startsWith('root.') && key !== 'root') {
      delete newNodes[key];
    }
  }

  return newNodes;
}


export function deleteNodesWithPrefix(
  nodes: { [key: string]: string[] },
  commonPrefix: string,
  values: string[]
): { [key: string]: string[] } {
  const newNodes: { [key: string]: string[] } = { ...nodes };

  for (const value of values) {
    const keyPrefix = commonPrefix + _pathSeparator + value;
    for(const key in newNodes){
      if(key.startsWith(keyPrefix)){
        delete newNodes[key];
      }
    }
    
  }

  return newNodes;
}


export async function executeOnceDaily(func: () => void, key:string) {
  const lastExecuted = await load('lastExecuted'+key, "");
  const today = new Date().toISOString().slice(0, 10);
  if (lastExecuted !== today) {
    func();
    store('lastExecuted'+key, today);
  }
}


/*
If l2image dictionary has missing entries that exists in cachedAutoL2image, add them to l2image and return the modified l2image.
The labels must be iterated from the nodes dictionary values.
*/
export async function addMissingEntriesFromCachedAutoL2imageToL2imageBulk(
  l2image: { [key: string]: string },
  cachedAutoL2image: { [key: string]: string[] },
  nodes: { [key: string]: string[] }
): Promise<{ [key: string]: string }> {
  const newL2image = { ...l2image };
  const labels = nodesToUniqueStrings(nodes);
  for (const label of labels) {
    const labelNorm = normalizeString(label);
    if (!newL2image.hasOwnProperty(label) && cachedAutoL2image.hasOwnProperty(labelNorm)) {
      newL2image[label] = cachedAutoL2image[labelNorm][0];
    }
  }
  return newL2image;
}

// Check Internet connection, returns true or false
export async function checkInternetConnection(): Promise<boolean> {
  const urls = [
    "https://www.google.com",
    "https://www.cloudflare.com/cdn-cgi/trace",
    "https://api.ipify.org",
    "https://ipv4.icanhazip.com",
  ];
  for (const url of urls) {
    try {
      const response = await fetch(url,  { mode: "no-cors" });
      return true;
    } catch (error) {
      // continue to the next URL
    }
  }
  return false;
}

export async function validateToken(label: string): Promise<boolean> {
  const tkn = await load(label,"");
  const uid = await load("uuid", "");
  const expected = await encryptData(label,uid+"uid");
  if(uid === ""){return Promise.resolve(false);}
  else{return tkn === expected}
}

export async function searchUnsplashImages(lang: string, query: string, limitResult: number): Promise<string[]> {
  //const accessKey = '...';
  const endpoint = `https://api.unsplash.com/search/photos?query=${encodeURIComponent(query)}&lang=${encodeURIComponent(lang)}&per_page=${limitResult}`;

  const response = await fetch(endpoint, {
    headers: {
      'Authorization': `Client-ID RAGHahnxtiEyS1hWZd_fQ1WotWzX79nLLrkRrSHYgSQ`,
    },
  });
  const data = await response.json();

  const images = await Promise.all(
    data.results.map(async (image: any) => {
      const response = await fetch(image.urls.regular);
      const blob = await response.blob();
      return new Promise<string>((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result as string);
        reader.readAsDataURL(blob);
      });
    })
  );
  return images;
}

async function translateToIT(input: string): Promise<string> {
  const normInput = normalizeString(input);
  const response = await fetch('data/files.json');
  const data = await response.json();
  const files = data.files.filter((file: {}) => {
    const fileName = Object.keys(file)[0];
    return fileName.startsWith('words') && !fileName.endsWith('it.txt');
  });
  let result = input;
  for (const file of files) {
    const fileName = Object.keys(file)[0];
    if (!fileName.endsWith('it.txt')) {
      const fileResponse = await fetch(`data/${fileName}`);
      const fileText = await fileResponse.text();
      const lines = fileText.split('\n').map((line) => normalizeString(line));
      const index = lines.indexOf(normInput);
      if (index !== -1) {
        const enFileName = fileName.replace(/_[a-z]{2}\.txt$/, '_it.txt');
        const enFileResponse = await fetch(`data/${enFileName}`);
        const enFileText = await enFileResponse.text();
        const enLines = enFileText.split('\n');
        result = enLines[index];
        break;
      }
    }
  }
  return result;
}


export function getDateString(){
  let date = new Date();
  let year = date.getFullYear();
  let day = String(date.getDate()).padStart(2, '0');
  let month = String(date.getMonth() + 1).padStart(2, '0');
  let formattedDate = `${year}${month}${day}`;
  return formattedDate;

}